import { Dispatch, SetStateAction, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'

import { TSplitType } from '../../models'
import { SplitPlanningSwitcher } from '../splitPlanningSwitcher/SplitPlanningSwitcher'

import { splitPlanningRowTranslation as tr } from './translations'

import styles from './SplitPlanningRow.module.scss'

export interface IProps {
  splitType: TSplitType
  setSplitType: Dispatch<SetStateAction<TSplitType>>
  isShowAllSplits: boolean
  setIsShowAllSplits: Dispatch<SetStateAction<boolean>>
  isDistributorPlanner: boolean
  colSpan: number
}

export const SplitPlanningRow = ({
  splitType,
  setSplitType,
  isShowAllSplits,
  setIsShowAllSplits,
  isDistributorPlanner,
  colSpan,
}: IProps) => {
  /** -------------------- Variables ----------------------- */

  const isShowAllSplitsCtrl = useMemo(() => splitType === 'Total', [splitType])
  const splitsTanslationKey = useMemo(
    () => (isDistributorPlanner ? tr.distributorSplits : tr.splits),
    [isDistributorPlanner]
  )

  /** -------------------- Render ----------------------- */

  return (
    <tr className={styles.splitPlanningRow}>
      <th colSpan={colSpan}>
        <div className={styles.splitPlanningContainer}>
          <SplitPlanningSwitcher
            splitType={splitType}
            setSplitType={setSplitType}
            isDistributorPlanner={isDistributorPlanner}
          />
          {isShowAllSplitsCtrl && (
            <div className={styles.splitPlanningItem}>
              <Checkbox
                checked={isShowAllSplits}
                onChange={() => setIsShowAllSplits((val) => !val)}
                label={<Translation text={splitsTanslationKey} span />}
              />
            </div>
          )}
        </div>
      </th>
    </tr>
  )
}
